/* tslint:disable */
/* eslint-disable */
/**
 * Tractable Identity Broker API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyToken200Response
 */
export interface VerifyToken200Response {
    /**
     * 
     * @type {object}
     * @memberof VerifyToken200Response
     */
    payload?: object;
}


/**
 * Check if a given object implements the VerifyToken200Response interface.
 */
export function instanceOfVerifyToken200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VerifyToken200ResponseFromJSON(json: any): VerifyToken200Response {
    return VerifyToken200ResponseFromJSONTyped(json, false);
}

export function VerifyToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payload': !exists(json, 'payload') ? undefined : json['payload'],
    };
}

export function VerifyToken200ResponseToJSON(value?: VerifyToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payload': value.payload,
    };
}

